<template>
<div class="">
                <button class="tab__header" @click.prevent="active = !active">
                    <a href="#" class="tab__link p-4 block" >
                        <strong>{{title}}</strong>
                        <span class="down-Arrow" v-show="!active">&#9660;</span>
                        <span class="up-Arrow" v-show="active">&#9650;</span>
                    </a>
                </button>
                <div class="tab__content_p-2" v-show="active"><slot /></div>            
            </div>
</template>

<script>
export default {
  name: 'Accordion',
  components: {},
  props: {
    title: String
  },
  methods: {

  },
  data() {
    return {
      active: false
    }
  }
}
</script>

<style>
    .message {
      margin-left: auto;
      margin-right: auto;
    }
    .message-header {
      cursor: pointer;
    }
    .message-body   {
      padding: 0;
      max-height: 10rem;
      overflow: hidden;
      transition: 0.3s ease all;
    }
    .is-closed .message-body {
      max-height: 0;
    }
    .message-content {
      padding: 20px;
    }
    span{
        float: right;
        color: #FF6816;
    }

    strong{
        text-decoration: none;
        float: left;
        color: #333333;
    }
    .tab__header{
        width: 100%;
        cursor: pointer;
        font-size: 1rem;
        padding: 0.75rem 0.75rem;
        background: white;
        border: none;
        outline: none;
        transition: 0.4s;
        margin-top: 1%;
        margin-bottom: 1%;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
    }

    strong:hover{
        color:#FF6816
    }


    .tab__content_p-2{
        font-size: 1rem;
    }
</style>